import { render, staticRenderFns } from "./UltimasNoticias.vue?vue&type=template&id=bcc53a68&scoped=true"
import script from "./UltimasNoticias.vue?vue&type=script&lang=js"
export * from "./UltimasNoticias.vue?vue&type=script&lang=js"
import style0 from "./UltimasNoticias.vue?vue&type=style&index=0&id=bcc53a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc53a68",
  null
  
)

export default component.exports